"use client";

import { ENUM_CUSTOMER_TABS } from "constants/customer";

const NoApplicationList = ({ tab }: { tab: ENUM_CUSTOMER_TABS }) => {
  const content = {
    [ENUM_CUSTOMER_TABS.APPLICATION_CONTRACT]: {
      title: "顧客情報はありません",
      desc: "申込・審査・契約の顧客情報がある場合に\nこのページで確認いただけます",
    },
    [ENUM_CUSTOMER_TABS.UNDER_CONTRACT]: {
      title: "顧客情報はありません",
      desc: "契約中の顧客情報がある場合に\nこのページで確認いただけます",
    },
    [ENUM_CUSTOMER_TABS.CONTRACT_CANCELLED]: {
      title: "顧客情報はありません",
      desc: "解約済みの顧客情報がある場合に\nこのページで確認いただけます",
    },
    [ENUM_CUSTOMER_TABS.WAITING_CONTRACT]: {
      title: "顧客情報はありません",
      desc: "空き待ち情報がある場合に\nこのページで確認いただけます",
    },
  };

  return (
    <div className="flex flex-col items-center justify-center rounded bg-white py-[97px]">
      <p className="mb-4 text-2xl">{content[tab].title}</p>
      <p className="whitespace-pre-line text-center text-gray">{content[tab].desc}</p>
    </div>
  );
};

export default NoApplicationList;
